import { render, staticRenderFns } from "./claim-list-state-toggle.vue?vue&type=template&id=65150b5d&"
import script from "./claim-list-state-toggle.vue?vue&type=script&lang=js&"
export * from "./claim-list-state-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports